import VForm from '@/vuetify_custom/v-form'
import { mapGetters } from 'vuex'
import { VBtn, VCard, VCardTitle, VCardText, VIcon } from 'vuetify/lib'
import Attachments from '@/views/components/file/attachments.vue'
import VTable from '@/vuetify_custom/v-table/v3'
import { publish_form_list } from '@/views/blogger/fields.js'
import VPopDel from './v-pop-del'
import styles from './index.module.less'
import VPopSelect from '@/vuetify_custom/v-pop-select.vue'
import {contract_types_mixins} from './EditMixIns.jsx'
// Textareas_Field
import { createTfRecordParams } from '../utils'
import { common_mixins } from './EditMixIns.jsx'
import { placing_ads_record_select_search } from '../service'
export default {
    mixins:[common_mixins, contract_types_mixins],
    data() {
        return {
            hash: {},
            is_expand: true
        }
    },
    computed: {
        ...mapGetters({
            contract_types_hash: 'async/contract_types_hash',
        }),
        cur_customer() {
            return this.$store.state.cur_customer;
          },
        is_financer() {
            return this.cur_customer.groups && this.cur_customer.groups.includes('GROUP_FIN');
        },
        placing_ads_ids_hash() {
            if (!this.params.ads_record_ids) {
                return {}
            }
            return this.params.ads_record_ids.reduce((t, i) => {
                if (i.id) {
                    t[i.id] = true
                }
                return t
            }, {})
        },
        table_fields() {
            const _this = this
            return [
                {
                    text: '投放编号',
                    align: 'center',
                    value: 'uid',
                    width: 240,
                }, 
                {
                    text: '预计投放时间',
                    align: 'center',
                    value: 'estimate_publish_at',
                    width: 120,
                },
                {
                    text: '发布时间',
                    align: 'center',
                    value: 'publish_at',
                    width: 120,
                },
                {
                    text: '发布类型',
                    align: 'center',
                    value: 'publish_form',
                    type: 'list_field',
                    item_key: 'value',
                    item_text: 'label',
                    items:publish_form_list,
                    width: 120,
                },
                {
                    text: '对接人',
                    align: 'center',
                    value: 'docking_customer_name',
                    width: 120,
                },
                {
                    text: '项目组',
                    align: 'center',
                    type: 'team_field',
                    value: 'team_id',
                    width: 120,
                },
                {
                    text: 'SKU',
                    align: 'center',
                    value: 'sku',
                    width: 120,
                    render:(_, t) => <div>{t.sku && t.sku.full_name || '-'}</div>
                },
                {
                    text: '预计投放金额',
                    align: 'center',
                    value: 'total_price',
                    type: 'money_field',
                    width: 120,
                },
                {
                    text: '付款进度',
                    type: 'money_field',
                    align: 'center',
                    value: 'paid_price',
                    width: 120,
                },
                {
                    text: '消耗进度',
                    type: 'money_field',
                    align: 'center',
                    value: 'consume_price',
                    width: 120,
                },
                {
                    text: '加成服务',
                    type: 'money_field',
                    align: 'center',
                    value: 'vas_amount',
                    width: 120,
                },
                {
                    text: '返点金额',
                    type: 'money_field',
                    align: 'center',
                    value: 'rebate_amount',
                    width: 120,
                },
                // {
                //     text: '投放类型',
                //     align: 'center',
                //     value: 'placing_type',
                //     width: 120,
                //     type: 'list_field',
                //     item_key: 'value',
                //     item_text: 'label',
                //     items: put_in_types
                // },
                {
                    text: '发布时间',
                    align: 'center',
                    value: 'publish_at',
                    width: 120,
                },
                {
                    text: '附件',
                    align: 'center',
                    value: 'bfiles',
                    width: 120,
                    render:(_, t) => {
                        if (!t.bfiles || !t.bfiles.length) {
                            return '-'
                        }
                        return <div>
                        <Attachments files={t.bfiles} showDetail={false}/>
                    </div>
                    } 
                },
                {
                    text: '操作',
                    align: 'center',
                    type: 'button_g_field',
                    value: 'action',
                     width: 120,
                     fixed: 'right',
                    render: (_, __, index) => {
                        // if (_this.params.contract_is_finished) {
                        //     return 
                        // }
                      
                        return <div>
                            <VPopDel
                                title="确定删除该条数据？"
                                on={{
                                    submit:() => {
                                        _this.params.ads_record_ids.splice(index, 1)
                                    }
                                }}
                            />
                    
                        </div>
                    }
                }
            ]
        },
        fields() {
            return [
                {
                    key:'table',
                    cols: 12,
                },
            ]
        }
    },
    methods: {
        changeUid(item, index) {
            this.$set(this.params.ads_record_ids, index, item)
        },
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                投放记录
                 <VBtn class={styles['btn-f']} 
                    outlined
                    color="primary"
                    small
                    on={{
                        click:() => {
                            // createlinkContractsParams
                            if (!_this.params.ads_record_ids) {
                                _this.$set(_this.params, 'ads_record_ids', [])
                            }
                            _this.params.ads_record_ids.push(createTfRecordParams())
                        }
                    }}
                    >
                    添加投放记录
                </VBtn>
                <VIcon color="primary" style="cursor: pointer;margin-left:20px" on={{click:() => {
                        this.is_expand = !this.is_expand
                }}}>{this.is_expand ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }</VIcon>
            </VCardTitle>
            <VCardText style={{display: this.is_expand ? 'block' : 'none'}}>
            <VForm
                ref="base"
                fields={_this.fields}
                scopedSlots={{
                    table:() => {
                        return <VTable
                            headers={this.table_fields}
                            desserts={this.params.ads_record_ids}
                            scopedSlots={{
                                uid:(value, target, index) => { 
                                    
                                    return <VPopSelect
                                    text = ''
                                    placeholder=''
                                    outParams={{
                                        // relate_contract:true,
                                        query_all:this.is_financer,
                                        relate_type: 'contract'
                                    }}
                                    // disabled={_this.params.contract_is_finished}
                                    outList={_this.params.ads_record_ids}
                                    url={placing_ads_record_select_search}
                                    handleSearch={(d) => {
                                           return d.filter(i => !this.placing_ads_ids_hash[i.id])
                                    }}
                                    rules={[]}
                                   //rules={[commonValidateRuleGo]}
                                    contentHeigh={400}
                                    on={{
                                        change(item) {
                                            _this.changeUid(item, index)
                                        }
                                    }}
                                    render = {
                                        (h, item) => {
                                            return <div>
                                                <p class={styles['p-c']}>
                                                    {item.uid}
                                                </p>
                                            </div>
                                        }
                                    }
                                    valueRender={() => {
                                 
                                        return target && target.uid || ''
                                    }}
                                />
                                }
                            }}
                        />
                    }
                }}
            />
            </VCardText>
        </VCard>
    </div>
    }
}